import React, { useEffect, useMemo, useState } from "react";
import {
  listarRecuperaciones,
  crearRecuperacion,
  actualizarRecuperacion,
  eliminarRecuperacion,
} from "../api";

export default function RecuperacionesTab() {
  const [items, setItems] = useState([]);
  const [cliente, setCliente] = useState("");
  const [servicio, setServicio] = useState("");
  const [notes, setNotes] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const totalSesiones = useMemo(
    () => items.reduce((acc, item) => acc + Number(item.cantidad || 0), 0),
    [items]
  );

  const cargar = async () => {
    try {
      setLoading(true);
      setError("");
      const data = await listarRecuperaciones();
      setItems(data.items || []);
    } catch (e) {
      setError(e.message || "Error al cargar recuperaciones");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargar();
  }, []);

  const handleCrear = async () => {
    if (!cliente.trim()) {
      alert("Escribe el cliente");
      return;
    }

    if (!servicio.trim()) {
      alert("Escribe el servicio");
      return;
    }

    try {
      await crearRecuperacion({
        cliente: cliente.trim(),
        servicio: servicio.trim(),
        cantidad: 1,
        notes: notes.trim(),
      });

      setCliente("");
      setServicio("");
      setNotes("");
      await cargar();
    } catch (e) {
      alert(e.message || "Error al crear recuperación");
    }
  };

  const cambiarCantidad = async (item, delta) => {
    const nuevaCantidad = Math.max(0, Number(item.cantidad || 0) + delta);

    if (nuevaCantidad === 0) {
      await handleEliminar(item);
      return;
    }

    try {
      await actualizarRecuperacion({
        id: item.id,
        cantidad: nuevaCantidad,
      });

      await cargar();
    } catch (e) {
      alert(e.message || "Error al actualizar recuperación");
    }
  };

  const handleEliminar = async (item) => {
    const ok = window.confirm(
      `¿Eliminar recuperación de ${item.cliente} - ${item.servicio}?`
    );

    if (!ok) return;

    try {
      await eliminarRecuperacion(item.id);
      await cargar();
    } catch (e) {
      alert(e.message || "Error al eliminar recuperación");
    }
  };

  return (
    <div className="cierre-panel">
      <h3>🔁 Recuperaciones</h3>

      <div className="balance-resumen" style={{ marginTop: 12 }}>
        <div className="balance-card ingresos">
          <span>Total sesiones debidas</span>
          <strong>{totalSesiones}</strong>
        </div>

        <div className="balance-card gastos">
          <span>Clientes/servicios activos</span>
          <strong>{items.length}</strong>
        </div>
      </div>

      <div className="balance-add" style={{ marginTop: 16 }}>
        <h4>Añadir recuperación</h4>

        <div className="balance-add-row">
          <input
            type="text"
            placeholder="Cliente"
            value={cliente}
            onChange={(e) => setCliente(e.target.value)}
          />

          <input
            type="text"
            placeholder="Servicio"
            value={servicio}
            onChange={(e) => setServicio(e.target.value)}
          />

          <input
            type="text"
            placeholder="Notas opcionales"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />

          <button type="button" className="btn-add" onClick={handleCrear}>
            ➕
          </button>
        </div>
      </div>

      {loading ? (
        <p>Cargando recuperaciones...</p>
      ) : error ? (
        <p className="balance-error">{error}</p>
      ) : items.length === 0 ? (
        <p>No hay recuperaciones registradas.</p>
      ) : (
        <div className="pv-table-wrapper" style={{ marginTop: "1rem" }}>
          <table className="pv-table">
            <thead>
              <tr>
                <th>Cliente</th>
                <th>Servicio</th>
                <th>Sesiones debidas</th>
                <th>Notas</th>
                <th>Acciones</th>
              </tr>
            </thead>

            <tbody>
              {items.map((item) => (
                <tr key={item.id}>
                  <td>
                    <strong>{item.cliente}</strong>
                  </td>
                  <td>{item.servicio}</td>
                  <td style={{ textAlign: "center" }}>
                    <strong>{item.cantidad}</strong>
                  </td>
                  <td>{item.notes || "-"}</td>
                  <td style={{ textAlign: "center" }}>
                    <button
                      type="button"
                      className="btn-recuperaciones"
                      onClick={() => cambiarCantidad(item, -1)}
                    >
                      -
                    </button>{" "}
                    <button
                      type="button"
                      className="btn-recuperaciones"
                      onClick={() => cambiarCantidad(item, 1)}
                    >
                      +
                    </button>{" "}
                    <button
                      type="button"
                      className="btn-recuperaciones"
                      onClick={() => handleEliminar(item)}
                    >
                      🗑️
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}